import { VehicleDetail } from 'chariot/types';
import { SET_VEHICLES_DATA } from './types';

const initialState: {
  vehiclesData: VehicleDetail[];
} = {
  vehiclesData: [],
};

function societyReactivationReducer(state = initialState, action) {
  const { type, data } = action;

  switch (type) {
    case SET_VEHICLES_DATA:
      return { ...state, vehiclesData: data };

    default:
      return state;
  }
}

export default societyReactivationReducer;
